<template>
  <div class="ribbon-wrapper">
    <div class="box">
      <div class="ribbon ribbon-top-right">
        <span>{{ text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ribbon',
  props: ['text'],
}
</script>
